import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { TryCatchStmt } from '@angular/compiler';
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';

import { Regla } from '../Models/Regla';

@Injectable()
export class ReglaService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }


  /**
   * Guarda el registro de la regla
   * @param Regla Objeto de tipo Regla
   */
  public GuardarRegistro(Regla: Regla) {

    try {

      let params = JSON.stringify(Regla);

      let url = this._utiles.getURL("Regla/");

      let headers = new Headers({ 'Content-Type': 'application/json' });

      let data: any;


      return this._http.post(url, Regla, { headers: headers }).map(res => res.json());

    } catch (error) {
      console.log(error);
    }


  }


  /**
   * Obtiene todas las reglas de la compañia que el usuario pueda ver
   * @param compania Codigo de la compañia
   */
  ObtenerReglas(compania: string): Observable<Regla[]> {

    try {

      let url = this._utiles.getURL("regla/" + compania);


      return this._http.get(url).map((response: Response) => {
        return <Regla[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


}
